import {AppState} from '../../Root.store'

export const selectDocuments = (state: AppState) => state.documents
